import Firebase from 'firebase/app'
import ReactGA from 'react-ga'

import { prepareDocForUpdate } from './helpers/firestoreHelpers'

const setContactInterval = ({personId, value, unit}) => {

  ReactGA.event({
    category: 'Person',
    action: 'Set interval',
  })
  
  // https://firebase.google.com/docs/firestore/manage-data/add-data#update_fields_in_nested_objects
  const update = {}
  if (value) {
    update['interval.value'] = parseInt(value, 10)
  }
  if (unit) {
    update['interval.unit'] = unit
  }

  return Firebase.firestore()
    .collection('people')
    .doc(personId)
    .update(prepareDocForUpdate(update))
    .catch( error => {
      alert(`Whoops, couldn't update contact interval for person: ${error.message}`)
    })
}

export default setContactInterval



// WEBPACK FOOTER //
// ./src/actions/setContactInterval.js